/**
 * A stripped down version of the log levels from rfc5424
 */
export enum LogLevel {
  /**
   * Critical conditions
   * @type {number}
   */
  Critical = 4,

  /**
   * Error conditions
   * @type {number}
   */
  Error = 3,

  /**
   * Warning conditions
   * @type {number}
   */
  Warn = 2,

  /**
   * Informational messages
   * @type {number}
   */
  Info = 1,

  /**
   * Debug-level messages
   * @type {number}
   */
  Debug = 0,
}
